export const env = process.env.NODE_ENV === 'production' ? { ...process.env, ...window['env'] } : process.env;
